// §11.12 / §9.1 — App Inspector as an in-process app.
//
// Everything it shows belongs to the kernel and to no app, so it is handed an
// `InspectorShellAccess` at composition (D-059) rather than reaching for the kernel, which
// `apps/**` may not do (§6.5).
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, InspectorShellAccess } from '@hangar/shared';
import { Inspector } from './Inspector';
import './inspector.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createInspectorApp(access: InspectorShellAccess): InProcessApp {
  return {
    id: 'inspector',
    name: 'App Inspector',
    icon: { glyph: 'microscope', hue: 178 },
    keywords: ['bridge', 'manifest', 'permissions', 'debug', 'developer', 'protocol'],
    window: { width: 860, height: 600, minWidth: 520, minHeight: 400, multiWindow: true },

    mount(container, api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Inspector api={api} access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
